import React from "react";
import FamilyDollarLogo from "../../images/familydollar.png";

const Header: React.FC = () => {
  return (
    <header>
      <h1 className="site-heading text-center text-faded d-none d-lg-block">
        <div id="companyLogo">
          <img
            className="companyLogoStyle img-fluid"
            src={FamilyDollarLogo}
            alt="Family Dollar"
          />
        </div>
      </h1>
    </header>
  );
};

export default Header;
